import { Component, OnInit } from '@angular/core';
// import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';

import { NotificationService } from './_services/notification.service';
import { AuthService } from './_services/auth.service';
import { ComponentBase } from './shared/base/base-component';
// import { filter } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent extends ComponentBase implements OnInit {
  title = 'thirteen-m-fifty';
  test: boolean;
    constructor(
    private notification: NotificationService
  ) {
    super();
  }
  ngOnInit(): void {
   
  }

  
}
